import type { ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ListCardProps {
  title: string | ReactNode;
  subTitle: string | ReactNode;
  onClick?: () => void;
  className?: string;
  endNode?: ReactNode;
}

export function ListCard({ title, subTitle, onClick, className, endNode }: ListCardProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        'bg-card border-border hover:bg-card/30 flex cursor-pointer items-center justify-between rounded-xl border p-3 transition-colors',
        className
      )}>
      <div className='min-w-0 flex-1 space-y-1'>
        <div className='flex items-center gap-2'>{title}</div>
        {subTitle}
      </div>
      <div className='flex items-center gap-2'>
        {endNode}
        <ChevronRight className='text-muted-foreground h-5 w-5 shrink-0' />
      </div>
    </div>
  );
}
